export default {
  created_at: 'some date',
  date_history: ['date2', 'date1'],
  ip_history: ['IP 2', 'IP 1'],
  last_used_at: 'some date and time',
  user_agent: 'iPhone',
}
